import {
    usersPermissionsFulfilledConstants,
    usersPermissionsRejectedConstants,
    usersPermissionsPendingConstants
} from '../actions';

const initialState = {
    data: [],
    error: '',
    loading: true
};

export default function (state = initialState, action) {
    switch (action.type) {
        case usersPermissionsPendingConstants.USERS_PERMISSIONS_LOADED:
            return initialState;
        case usersPermissionsFulfilledConstants.USERS_PERMISSIONS_LOADED:
            return {
                data: [...action.payload.users],
                loading: false
            };
        case usersPermissionsRejectedConstants.USERS_PERMISSIONS_LOADED:
            return {
                ...state,
                error: `${action.payload.response.data.errorMessage || action.payload.response.status + ' ' + action.payload.response.statusText}`,
                loading: false
            };
        case usersPermissionsFulfilledConstants.USER_PERMISSION_CREATED:
            return {
                ...state,
                loading: false,
                data: [...state.data, action.payload]
            };
        case usersPermissionsFulfilledConstants.USER_PERMISSION_UPDATED:
            return {
                ...state,
                loading: false,
                data: state.data.map(c => (c.userId === action.payload.userId ? action.payload : c))
            };
        case usersPermissionsFulfilledConstants.USER_PERMISSION_DELETED:
            return {
                ...state,
                data: state.data.filter(c => c.userId !== action.payload)
            };
        case usersPermissionsPendingConstants.USER_PERMISSION_CREATED:
        case usersPermissionsPendingConstants.USER_PERMISSION_UPDATED:
            return {
                ...state,
                loading: true
            };
        case usersPermissionsRejectedConstants.USER_PERMISSION_CREATED:
        case usersPermissionsRejectedConstants.USER_PERMISSION_UPDATED:
        case usersPermissionsRejectedConstants.USER_PERMISSION_DELETED:
            return {
                ...state,
                loading: false,
                error: `${action.payload.response.data.errorMessage || action.payload.response.status + ' ' + action.payload.response.statusText}`,
                ...action.payload.response.data
            };
        default:
            return state;
    }
}
